import React, { useEffect, useState } from "react";
import { TextHeader, TextDescription } from "components/Texts";
import { useDispatch, useSelector } from "react-redux";
import Button from "components/Buttons";

import Row from "components/Row";
import Column from "components/Column";
import Section from "components/Section";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import facebookActions from "modules/facebook/actions";
import facebookSelectors from "modules/facebook/selectors";
import LoadingContainer from "components/LoadingContainer";
import LoginModal from "components/facebook/LoginModal";
import Loading from "components/gads/Loading";

const AdsConnected = () => {
  const { REACT_APP_RMP_APP_ID, REACT_APP_FACEBOOK_RP_BUSINESS_ID } = process.env;
  const dispatch = useDispatch();
  const rmpToken = sessionStorage.getItem("rmp_token");
  const [loading] = useState(false);
  const getFacebookSettingsResult = useSelector((state) => facebookSelectors.getFacebookSettingsResult(state));
  const [showLoadingContainer, setShowLoadingContainer] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState(true);
  const [checkedAdsAccountFailed, setCheckedAdsAccountFailed] = useState(false);
  const [checkedPixelFailed, setCheckedPixelFailed] = useState(false);
  const [checkedPixelConnectedAdsFailed, setCheckedPixelConnectedAdsFailed] = useState(false);
  const [modalLoginFacebookDisplay, setModalLoginFacebookDisplay] = useState("hide");
  const menu = "facebook_ads_setup";

  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();

  useEffect(() => {
    getFacebookSettings();
  }, []);

  const checkConnectionStatus = (adsAccountAgencies, pixelAgencies, facebookSettings) => {
    return new Promise((resolve, reject) => {
      let result = true;

      if (
        adsAccountAgencies.result !== 0 ||
        (adsAccountAgencies.data.data &&
          adsAccountAgencies.data.data.length === 0 &&
          facebookSettings.data[0].fb_ads_business_id !== REACT_APP_FACEBOOK_RP_BUSINESS_ID)
      ) {
        result = false;
        setCheckedAdsAccountFailed(true);
      }

      if (pixelAgencies.result !== 0 || (pixelAgencies.data.data && pixelAgencies.data.data.length === 0)) {
        if (pixelAgencies.message === "NO_CONNECTED_ADS") {
          result = false;
          setCheckedPixelConnectedAdsFailed(true);
        } else if (
          pixelAgencies.message === "NO_RP_AGENCY" &&
          facebookSettings.data[0].fb_ads_business_id === REACT_APP_FACEBOOK_RP_BUSINESS_ID
        ) {
          // Do Nothing
        } else {
          result = false;
          setCheckedPixelFailed(true);
        }
      }

      resolve(result);
    });
  };

  const getFacebookSettings = async () => {
    try {
      handleShowLoadingContainer(true);

      let checkConnectionStatusResult = false;
      const facebookSettings = await dispatch(
        facebookActions.getFacebookSettings({
          token: rmpToken,
        }),
        rmpToken,
      );

      if (facebookSettings.result === 0 && facebookSettings.data.length > 0) {
        const adsAccountAgencies = await dispatch(
          facebookActions.getFacebookAdsAccountAgencies({
            token: rmpToken,
            ads_account_id: `act_${facebookSettings.data[0].fb_ads_account_id}`,
          }),
        );

        const pixelAgencies = await dispatch(
          facebookActions.getFacebookPixelAgencies({
            token: rmpToken,
            ads_account_id: facebookSettings.data[0].fb_ads_account_id,
            user_access_token: "",
            pixels_id: facebookSettings.data[0].fb_ads_pixel_code_id,
          }),
        );

        checkConnectionStatusResult = await checkConnectionStatus(adsAccountAgencies, pixelAgencies, facebookSettings);

        if (checkConnectionStatusResult === true) {
          handleConnectionStatus(true);
        } else {
          handleConnectionStatus(false);
        }
        handleShowLoadingContainer(false);
      } else {
        handleShowLoadingContainer(false);
        dispatch(facebookActions.changeSettingPage("signin"));
      }
    } catch (error) {
      handleShowLoadingContainer(false);
    }
  };

  const handleEditButton = () => {
    setModalLoginFacebookDisplay("show");
  };

  const handleShowLoadingContainer = (value) => {
      setShowLoadingContainer(value);
  };

  const handleConnectionStatus = (value) => {
    if (menu === sessionStorage.getItem("selectedMenu")) {
      setConnectionStatus(value);
    }
  };

  const view = () => {
    return (
      <RelativeContainer>
        <SetupTextHeader>{t("__fbads_setup_title")}</SetupTextHeader>

        {showLoadingContainer ? (<Loading/>) : connectionStatus === true ? (
          <SuccessReportContainer>
            <ReportCenteredDiv>
              <b>{t("__fbads_connected_account_connected")}</b>
            </ReportCenteredDiv>
          </SuccessReportContainer>
        ) : (
          <ErrorReportContainer>
            <ReportCenteredDiv>
              <b>{t("__fbads_connected_account_not_connected")}</b>
            </ReportCenteredDiv>

            <ul>
              {checkedAdsAccountFailed === true && <li>{t("__fbads_connected_account_error_ads_failed")}</li>}
              {checkedPixelFailed === true && (
                <li>
                  {t("__fbads_connected_account_error_pixel_failed")}
                  <br />
                </li>
              )}
              {checkedPixelConnectedAdsFailed === true && (
                <li>
                  {t("__fbads_connected_account_error_pixel_connected_ads_failed")}
                  <br />
                </li>
              )}
            </ul>
          </ErrorReportContainer>
        )}

        <ConnectedMainContainer>
          <DataRow>
            <Column>
              <TextDescription size="10px">{t("__fbads_connected_account_business")}</TextDescription>
              <div>
                {getFacebookSettingsResult.data[0] && getFacebookSettingsResult.data[0].fb_ads_business_name
                  ? getFacebookSettingsResult.data[0].fb_ads_business_name
                  : ""}
              </div>
              <TextDescription size="10px">
                ID:{" "}
                {getFacebookSettingsResult.data[0] && getFacebookSettingsResult.data[0].fb_ads_business_name
                  ? getFacebookSettingsResult.data[0].fb_ads_business_id
                  : ""}
              </TextDescription>
            </Column>
            <Column>
              <TextDescription size="10px">{t("__fbads_connected_account_ads")}</TextDescription>
              <div>
                {getFacebookSettingsResult.data[0] && getFacebookSettingsResult.data[0].fb_ads_business_name
                  ? getFacebookSettingsResult.data[0].fb_ads_account_name
                  : ""}
              </div>
              <TextDescription size="10px">
                ID:{" "}
                {getFacebookSettingsResult.data[0] && getFacebookSettingsResult.data[0].fb_ads_business_name
                  ? getFacebookSettingsResult.data[0].fb_ads_account_id
                  : ""}
              </TextDescription>
            </Column>
          </DataRow>
          <DataRow>
            <Column>
              <TextDescription size="10px">{t("__fbads_connected_account_pixel")}</TextDescription>
              <div>
                {getFacebookSettingsResult.data[0] && getFacebookSettingsResult.data[0].fb_ads_business_name
                  ? getFacebookSettingsResult.data[0].fb_ads_pixel_code_id
                  : ""}
              </div>
            </Column>
          </DataRow>

          <ButtonRow>
            <Button type="secondary" onClick={handleEditButton} loading={loading} round>
              {t("__ads_connected_account_edit")}
            </Button>
          </ButtonRow>
        </ConnectedMainContainer>

        <LoginModal show={modalLoginFacebookDisplay} setShow={setModalLoginFacebookDisplay} />
      </RelativeContainer>
    );
  };

  return view();
};

export default AdsConnected;

const SetupTextHeader = styled(TextHeader)`
  font-size: 18px;
  margin-bottom: 10px;
`;

const DataRow = styled(Row)`
  margin-bottom: 10px;

  .text-green {
    color: #4caf50;
  }

  .text-red {
    color: #f44336;
  }
`;

const ConnectedMainContainer = styled.div`
  background-color: #fbfeff;
  border-radius: 10px;
  border: 1px solid #f5f9fc;
  padding: 20px;
`;

const ButtonRow = styled(DataRow)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RelativeContainer = styled.div`
  position: relative;
`;

const ErrorReportContainer = styled.div`
  padding: 0.75rem 1.25rem 0px;
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  border-radius: 0.25rem;
  width: 100%;
  margin: 20px 0px;
  box-sizing: border-box;
`;

const SuccessReportContainer = styled.div`
  padding: 0.75rem 1.25rem;
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 0.25rem;
  width: 100%;
  margin: 20px 0px;
  box-sizing: border-box;
`;

const ReportCenteredDiv = styled.div`
  display: flex;
  justify-content: center;
`;
